import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ListFacetSharedObject,
  NewSearchFacetButtonViewModel,
  ToggleFacetEvent,
} from '@app/new-search/models/new-search-facets.model';
import {
  CategoryFacet,
  DateFacet,
  GeneratedFacetControllers,
  LocationFacet,
  NumericFacet,
  RegularFacet,
  RegularFacetValue,
} from '@coveo/headless/commerce';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-new-search-actions',
  templateUrl: './new-search-actions.component.html',
  styleUrls: ['./new-search-actions.component.scss'],
})
export class NewSearchActionsComponent implements OnChanges {
  @Input() facets: GeneratedFacetControllers;
  @Input() isMobile = false;
  @Input() anyFacetSelected = false;
  @Input() deliveryTypeFacet: RegularFacet;
  @Input() usfDeliveredFacetValue: RegularFacetValue;
  @Input() ourExclusivesFacet: RegularFacet;
  @Input() listFacet: ListFacetSharedObject;

  @Output() facetButtonPressed = new EventEmitter<string>();
  @Output() allFiltersPressed = new EventEmitter();
  @Output() facetsSelected = new EventEmitter<ToggleFacetEvent>();
  @Output() facetListSelected = new EventEmitter<void>();

  facetButtonVms: NewSearchFacetButtonViewModel[] = [];
  ourExclusivesVM: NewSearchFacetButtonViewModel;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.facetButtonVms = changes?.facets?.currentValue
      ?.slice(0, 5)
      .map(facet => {
        return {
          facet: facet,
          facetDisplayMessage: this.getFacetButtonMessage(facet),
        };
      });
    this.ourExclusivesVM = {
      facet: changes.ourExclusivesFacet?.currentValue,
      facetDisplayMessage: this.getFacetButtonMessage(
        changes?.ourExclusivesFacet?.currentValue,
      ),
    };
  }

  onFacetButtonPress(facetId: string) {
    this.facetButtonPressed.emit(facetId);
  }

  getFacetButtonMessage(
    facet:
      | RegularFacet
      | DateFacet
      | NumericFacet
      | CategoryFacet
      | LocationFacet,
  ) {
    switch (facet?.type) {
      case 'regular':
      case 'hierarchical':
        return facet.state.hasActiveValues
          ? `${facet.state.displayName} (${facet.state.values.filter(value => value.state === 'selected').length})`
          : facet.state.displayName;
      default:
        break;
    }
  }

  onAllFiltersPressed() {
    this.allFiltersPressed.emit();
  }

  onCloseIconClick($event: Event, facet: RegularFacet | CategoryFacet) {
    $event.stopPropagation();
    facet.deselectAll();
  }

  handleCheckboxSelection() {
    this.facetsSelected.emit({
      facet: this.deliveryTypeFacet,
      value: this.usfDeliveredFacetValue,
    });
  }

  onListFacetButtonPress() {
    this.facetButtonPressed.emit(this.listFacet?.displayName);
  }

  onCloseListFacet() {
    this.listFacet.values.forEach((value, key) => {
      value.isSelected = false;
    });
    this.listFacet.isValuesSelected = false;
    this.facetListSelected.emit();
  }
}
